import Icon from 'app/visuals/images/icons/location-selector.svg?react';
import { styled } from 'styled-components';

export const LocationSelectorIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.mono.text02};
  width: 24px;
  height: 24px;
`;
